module.exports = __webpack_public_path__ + "img/star.04ee8b48.png";